class ClickToggleElement extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this);
  }

  handleEvent(e) {
    if (e.type === "click") {
      this.toggleAttribute("open");
    }
  }
}

customElements.define("click-toggle", ClickToggleElement);
